import React from 'react';
import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomerServicePackageStatusChip from './CustomerServicePackageStatusChip';
import { getCustomerServicePackageDisplay } from './servicePackageDisplay';

const CustomerServicePackagesTable = ({
  customerPackages,
  canCancelPackages,
  cancellingId,
  onCancel,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <TableContainer id="customer-service-packages-table" sx={{ overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('servicePackagesManagement.customerPackages.table.customer')}</TableCell>
            <TableCell>{t('servicePackagesManagement.customerPackages.table.package')}</TableCell>
            <TableCell>{t('servicePackagesManagement.customerPackages.table.status')}</TableCell>
            <TableCell>{t('servicePackagesManagement.customerPackages.table.uses')}</TableCell>
            <TableCell>{t('servicePackagesManagement.customerPackages.table.channel')}</TableCell>
            <TableCell>{t('servicePackagesManagement.customerPackages.table.purchased')}</TableCell>
            <TableCell>{t('servicePackagesManagement.customerPackages.table.expires')}</TableCell>
            <TableCell align="right">{t('servicePackagesManagement.customerPackages.table.price')}</TableCell>
            {canCancelPackages ? (
              <TableCell align="right">{t('servicePackagesManagement.customerPackages.table.actions')}</TableCell>
            ) : null}
          </TableRow>
        </TableHead>
        <TableBody>
          {customerPackages.map((customerPackage) => {
            const display = getCustomerServicePackageDisplay(customerPackage, i18n.language, t);

            return (
              <TableRow key={customerPackage.id} id={`customer-service-package-row-${customerPackage.id}`} hover>
                <TableCell>
                  <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {display.customerName}
                    </Typography>
                    {customerPackage.customerEmail ? (
                      <Typography variant="caption" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
                        {customerPackage.customerEmail}
                      </Typography>
                    ) : null}
                  </Stack>
                </TableCell>
                <TableCell>{display.packageName}</TableCell>
                <TableCell>
                  <CustomerServicePackageStatusChip effectiveStatus={customerPackage.effectiveStatus} />
                </TableCell>
                <TableCell>{display.usesLabel}</TableCell>
                <TableCell>{display.channelLabel}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{display.purchasedLabel}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{display.expiresLabel}</TableCell>
                <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>{display.priceLabel}</TableCell>
                {canCancelPackages ? (
                  <TableCell align="right">
                    {customerPackage.canCancel ? (
                      <Button
                        id={`customer-service-package-cancel-${customerPackage.id}`}
                        size="small"
                        variant="outlined"
                        color="error"
                        disabled={cancellingId === customerPackage.id}
                        onClick={() => onCancel(customerPackage)}
                        sx={{ whiteSpace: 'nowrap' }}
                      >
                        {t('servicePackagesManagement.customer.cancel.action')}
                      </Button>
                    ) : null}
                  </TableCell>
                ) : null}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomerServicePackagesTable;
